<template>
    <div class="wrapper">
        <page>
            <div class="page-content-box" slot="page-content-w100" v-if="has_load">
                <div class="content-left max-width-640">
                    <auth-door v-if="is_verified == 0 && !is_self"/>
                    <feed
                        v-else-if="post"
                        ref="feed"
                        :post="post"
                        :group="post.group"
                        :old_new="post.group_id ? {} : old_new"
                        :user="post.user"
                        :is_init_load_comment="post_id != 'd5477d7c24de11e993d952540025c377'"
                        :footer_type="true"
                        :is_show_content_all="true"
                        :is_post_page="true"
                        :is_need_toolbar="true"
                        @mounted="feed_mounted"
                    >
                        <div slot="slot-1" v-if="browser_size == 'small' && post && !is_applying_apple">
                            <album-card class="mt16" v-for="(album, i) in post.albums" :key="i" :album="album"/>
                        </div>
                    </feed>
                </div>
                <div class="content-right">
                    <avatar-card
                        class="mb16"
                        v-if="post"
                        :user="post.user"
                        :sponsor_info="sponsor_info"
                        :is_hide_sponsor_btn="post.group_id ? false : true"
                    ></avatar-card>
                    <template v-if="browser_size != 'small' && post">
                        <album-card class="mb16" v-for="(album, i) in post.albums" :key="i" :album="album"/>
                    </template>
                    <div class="flex-box flex-direction-column" v-if="post && !is_applying_apple && !is_applying_google && !GL.ENV.is_wechat_mini && !post.group_id">
                        <template v-for="(plan, i) in plans.concat(plan_sale_list)">
                            <plan v-if="is_all_show ? true : plan.product_type == 1 && limit_show_product_count > 0 ? i < (plans.length * 1 + limit_show_product_count * 1) : true"
                                :key="i"
                                :renew_plan="renew_plan"
                                :style="{ order: i + 1 }"
                                :plan="plan"
                                :renew_infos_independent="renew_infos_independent"
                                :product_type="plan.product_type"
                            ></plan>
                        </template>
                        <plan v-if="post.user.creator.custom_plan != plan_status.hide"
                            :style="{order:
                                    post.user.creator.custom_plan ==
                                    custom_plan_status.top ? 0 : plans.concat(plan_sale_list).length + 1,}"
                            :is_custom="true"
                            :user="post.user"
                            :renew_infos_independent="renew_infos_independent"
                        ></plan>
                    </div>
                    <btn v-if="!is_all_show && ((limit_show_product_count > 0 && limit_show_product_count < plan_sale_list.length) || sale_has_more)" class="look13 w100 pt10 pb10 mt16 fs14" @click.native="show_more">{{$t('pPostId.text1')}}</btn>
                    <template v-if="post && post.group_id">
                        <div v-if="browser_size == 'small'" class="fwb mb16">
                            {{$t('pPostId.text2')}}
                        </div>
                        <group-card :group="post.group"></group-card>
                    </template>
                </div>
            </div>
        </page>
    </div>
</template>
<script>
import AlbumCard from "@/components/AlbumCard";
import { GET_POST_GET_DETAIL, GET_USER_SPONSOR_INFO,GET_PRODUCTS } from "@/api/config";
import { mapState } from "vuex";
export default {
    // metaInfo() {
    //   return {
    //     title: this.post
    //       ? this.post.type == this.feed_type.normal
    //         ? `${this.post && this.post.user.name}发布的内容 | 爱发电`
    //         : `${this.post && this.post.title} | ${this.post &&
    //             this.post.user.name} | 爱发电`
    //       : ""
    //   };
    // },
    metaInfo() {
        let tit = "";
        let key = "";
        let url = location.href;
        let desc = this.$remove_html_tag(this.post && this.post.content || '');
        let c_name = "";
        if (this.post && this.post.title && this.this_user) {
            tit = `${this.post.title}丨${this.this_user.name}丨爱发电`;
        }
        if (this.post && this.post.title == "" && this.this_user) {
            tit = `${this.post.content
                .replace(/<\/?.+?\/?>/g, "")
                .substring(0, 18)}...丨${this.this_user.name}丨爱发电`;
        }
        if (this.this_user && this.this_user.creator) {
            let u = this.this_user;
            let creator = this.this_user && this.this_user.creator;
            if (creator) {
                if (creator.category) {
                    c_name = creator.category.name;
                }
            }
            key = `爱发电，赞助，${u.name}，${creator.doing}，${c_name}，发电，Patreon，kickstarter`;
        }
        return {
            title: tit,
            meta: [
                {
                    name: "keywords",
                    content: key,
                },
                {
                    property:'og:title',
                    content: tit,
                },
                {
                    property:'og:description',
                    content: desc,
                },
                {
                    property:'og:url',
                    content: url,
                },
                {
                    name: "browsermode",
                    content: 'application',
                },
            ].concat(this.$noindex_metas(this.this_user)),
        };
    },
    data() {
        return {
            post_id: this.$route.params.postId,
            post: null,
            sponsor_info: null,
            old_new: null,
            has_load:false,
            is_auto_show_feed: localStorage.getItem("FEED_PUBLISH_SUCCESS_ID"),
            is_all_show:false,
            product_list:[]
        };
    },
    watch: {
        // is_auto_show_feed() {
        //   console.log("is_auto_show_feed");
        //   this.open_share();
        // },
        // post() {
        //   console.log("post");
        //   this.open_share();
        // }
        // '$refs': {
        //     handler: function() { console.log("hit"); },
        //     deep: true
        // }
    },
    components: {
        AlbumCard
    },
    computed: {
        ...mapState("app", [
            "session_user",
            "browser_size",
            "plan_status",
            "custom_plan_status",
            "feed_type",
            "is_applying_apple",
            "is_applying_google",
            "white_list",
            "black_list",
        ]),
        ...mapState("user", ["this_user"]),
        ...mapState("order", [
            "plans",
            "plan_sale_list",
            "sale_has_more",
            "renew_plan",
            "renew_infos_independent",
            'limit_show_product_count',
        ]),
        is_self() {
            return (
                this.session_user && this.this_user && this.this_user.user_id == this.session_user.user_id
            );
        },
        can_copy_text(){
            if (
                this.this_user &&
                this.this_user.creator &&
                this.this_user.creator.can_copy_text
            ) {
                return true;
            }
            return false;
        },
        can_copy_pic(){
            if (
                this.this_user &&
                this.this_user.creator &&
                this.this_user.creator.can_copy_pic
            ) {
                return true;
            }
            return false;
        },
        is_verified(){
            if (
                this.this_user &&
                this.this_user.is_verified ||
                this.post && this.post.group_id
            ) {
                return 1;
            }
            return 0;
        },
    },
    async beforeMount() {
        this.$bus.$off("FEED_PUBLISH_SUCCESS");
        this.$bus.$on("FEED_PUBLISH_SUCCESS", () => {
          this.get_post();
        });
        this.$bus.$on('VISIBILITYCHANGE', (data) => {
          if(data.is_show && this.is_auto_show_feed){
            this.get_post()
            localStorage.removeItem("FEED_PUBLISH_SUCCESS_ID");
          }
        });

        await this.get_post();
        let re = await this.$mixin_check_post_permission(this.post);
        if(!re){
            return false;
        }
        if(re && this.session_user){
            this.get_user_sponsor_info();
        }

        this.has_load = true;
        if (this.post && this.post.user) {
            await this.$store.dispatch("order/get:plans", {
                user_id: this.post.user.user_id,
            });
        }
        this.$nextTick(() => {
            if(this.is_verified == 0 && this.is_self || (this.post && this.post.self_only == 1)){
            }else{
                if(this.post && this.post.status != 3){
                    this.open_share();
                }
            }
            localStorage.removeItem("FEED_PUBLISH_SUCCESS_ID");
        });
    },
    async mounted() {
      // setTimeout(() => {
      //   console.log(this.$refs.feed.share_config)
      // },2000)
        if (this.GL.ENV.is_afd_client) {
            //供app 右上角调用
            window.app_call_share = () => {
                this.$bridge.call(
                    "share",
                    this.$refs.feed.share_config,
                    () => {}
                );
            };
        }
    },
    beforeDestroy() {
      this.$bus.$off("FEED_PUBLISH_SUCCESS");
      this.$bus.$off('VISIBILITYCHANGE')
    },
    methods: {
        show_more(){
            this.is_all_show = true;
        },
        async show_more(){
          this.is_all_show = true;
          await this.get_products('', true)
          this.$store.dispatch("order/set:plan_sale_list", this.product_list);
        },
        async get_products() {
          if (this.$http.is_run(GET_PRODUCTS)) {
            return false;
          }
          let data = await this.$http.$axios(GET_PRODUCTS, {
            user_id: this.post.user.user_id,
          });
          if (data.ec != 200) {
            this.$notify({
              title: data.em,
              group: "error",
            });
            return false;
          }
          this.product_list = data.data.list;
        },
        feed_mounted(){
            if(this.GL.ENV.is_wechat){
                let config = this.$refs.feed.share_config;
                this.$wx_jssdk_ready(config.url,() => {
                    this.$wx_share(config)
                })
            }
        },
        open_share() {
            if (this.is_auto_show_feed && this.post) {
                this.$refs.feed.$refs.footer_share.open_menu();
                // this.GL.FEED_PUBLISH_SUCCESS = false;
            }
        },
        async get_post() {
            if (this.$http.is_run(GET_POST_GET_DETAIL)) {
                return false;
            }
            let data = await this.$http.$axios(GET_POST_GET_DETAIL, {
                post_id: this.post_id,
            });

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                return false;
            }
            // data.data.post.pics = data.data.post.pics.splice(9,60);
            this.post = null;
            this.old_new = null
            this.$nextTick(() => {
                this.post = data.data.post;
                this.old_new = data.data.old_new;
            })
            this.$store.dispatch("user/set:this_user", data.data.post.user);
        },
        async get_user_sponsor_info() {
            if (this.$http.is_run(GET_USER_SPONSOR_INFO)) {
                return false;
            }
            let data = await this.$http.$axios(GET_USER_SPONSOR_INFO, {
                user_id: this.post.user.user_id,
            });

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                return false;
            }
            this.sponsor_info = data.data.sponsor_info;
        },
    },
};
</script>

<style lang="stylus" scoped>
.wrapper{
  .page-content-box {
    display: flex;
  }

  .content-right {
    width: 320px;
    margin-left: px2rem(40);

    .vm-avatar-card /deep/{
      .vm-btn {
        width: 100%;
      }
    }

    .vm-plan /deep/{
      .btn-box, .vm-btn {
        width: 100%;
      }
    }
  }

  .vm-plan {
    margin-bottom: px2rem(16);
  }

  @media (max-width: $width-mobile) {
    padding-bottom: $nav-mobile-height;

    .page-content-box {
      display: block;
    }

    .content-right {
      width: 100%;
      margin-left: px2rem(0);
      margin-top: px2rem(24);
      padding-left: px2rem(16);
      padding-right: px2rem(16);
      box-sizing: border-box;
    }

    .vm-page /deep/{
      padding-bottom: px2rem(24);

      .page-box {
        padding-left: 0;
        padding-right: 0;
        // margin-top: px2rem(48);
      }

      .vm-nav-header {
        background: $white;
      }
    }

    .vm-feed {
      padding-left: 16px;
      padding-right: 16px;
      border-width: 0 0 1px 0;
    }
  }
}
</style>
